module.exports = __webpack_public_path__ + "img/app-ios-1.9e2d7214.png";